const it = {
  tools_actions: {
    hotel_info: "Cercando informazioni sull'hotel...",
    accommodation_info: "Cercando informazioni sull'hotel...",
    accomodation_info: "Cercando informazioni sull'hotel...",
    get_destination_info: "Cercando cosa fare nei dintorni...",
    get_guest_information: "Controllo la tua prenotazione...",
    book_hotel_service_or_get_availability: "Verifico la disponibilità del servizio...",
    list_accomodations: "Carico le strutture...",
    set_accomodation: "Carico la struttura...",
    list_accommodations: "Carico le strutture...",
    set_accommodation: "Carico la struttura...",
    destination_info: "Cercando cosa fare nei dintorni...",
    show_map: "Preparo la mappa...",
    consult_rules: "Consulto le regole della struttura...",
    notify_reception: "Avviso la reception...",
    save_self_declared_stay: "Registro il tuo soggiorno...",
    generate_quote_for_single_room_longstay_rooms: "Preparo un preventivo...",
    generate_quote_for_multiple_rooms_longstay: "Preparo un preventivo...",
    hotel_info_iodah:
      "Perfetto, raccolgo l'informazione e sarò subito da lei...",
    generate_quote_for_rooms: "Preparando un preventivo...",
    check_availability: "Controllo disponibilità...",
    print_calendar: "Controllo calendario...",
    nearby_restaurants: "Cercando ristoranti nelle vicinanze...",
    nearby_attractions: "Cercando attrazioni nelle vicinanze...",
    human_handoff: "Collegamento con un operatore...",
    tool_search_offers_by_request:
      "Sto cercando le migliori offerte per te...",
    tool_search_hotels_by_request: "Sto cercando i migliori hotel per te...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "Controllo le disponibilità per le tue date…",
      "Confronto camere e tariffe…",
      "Preparo il preventivo…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "Controllo le disponibilità per le tue date…",
      "Confronto camere e tariffe…",
      "Preparo il preventivo…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "Controllo le disponibilità per le tue date…",
      "Confronto camere e tariffe…",
      "Preparo il preventivo…",
    ],
    check_availability: [
      "Controllo il calendario…",
      "Verifico le disponibilità…",
      "Un attimo ancora…",
    ],
    hotel_info: [
      "Consulto le informazioni dell'hotel…",
      "Recupero i dettagli…",
      "Preparo la risposta…",
    ],
    accommodation_info: [
      "Consulto le informazioni dell'hotel…",
      "Recupero i dettagli…",
      "Preparo la risposta…",
    ],
    accomodation_info: [
      "Consulto le informazioni dell'hotel…",
      "Recupero i dettagli…",
      "Preparo la risposta…",
    ],
    get_destination_info: [
      "Esploro i dintorni…",
      "Raccolgo i suggerimenti migliori…",
      "Quasi pronto…",
    ],
    nearby_restaurants: [
      "Cerco i ristoranti in zona…",
      "Seleziono i più adatti…",
      "Quasi pronto…",
    ],
    nearby_attractions: [
      "Cerco cosa fare nei dintorni…",
      "Seleziono il meglio…",
      "Quasi pronto…",
    ],
    get_guest_information: [
      "Recupero la tua prenotazione…",
      "Controllo i dettagli del soggiorno…",
      "Un attimo ancora…",
    ],
    book_hotel_service_or_get_availability: [
      "Controllo la disponibilità del servizio…",
      "Verifico gli orari…",
      "Un attimo ancora…",
    ],
    print_calendar: ["Apro il calendario…", "Controllo le date…"],
    list_accomodations: ["Carico le strutture…", "Preparo l'elenco…"],
    set_accomodation: ["Apro la struttura…", "Recupero le informazioni…"],
    list_accommodations: ["Carico le strutture…", "Preparo l'elenco…"],
    set_accommodation: ["Apro la struttura…", "Recupero le informazioni…"],
    destination_info: [
      "Esploro i dintorni…",
      "Raccolgo i suggerimenti migliori…",
      "Quasi pronto…",
    ],
    show_map: ["Individuo i luoghi sulla mappa…", "Preparo l'itinerario…"],
    consult_rules: ["Consulto le regole della struttura…", "Verifico le condizioni…"],
    notify_reception: ["Avviso la reception…", "Inoltro la richiesta…"],
    save_self_declared_stay: ["Registro il tuo soggiorno…", "Collego la prenotazione…"],
    human_handoff: ["Avviso la reception…", "Passo la conversazione…"],
    tool_search_offers_by_request: [
      "Cerco le migliori offerte per te…",
      "Confronto le soluzioni…",
      "Quasi pronto…",
    ],
    tool_search_hotels_by_request: [
      "Cerco gli hotel più adatti…",
      "Confronto le soluzioni…",
      "Quasi pronto…",
    ],
  },
  status_thinking: ["Un attimo…", "Ci sto pensando…", "Ancora un istante…"],
  status_generic: ["Ci siamo quasi…", "Ancora un istante…"],
  tooltip_sentences: [
    "Vuoi un preventivo veloce? 😊",
    "Vuoi informazioni sull'hotel? 😊",
  ],
  welcome_message_default:
    "Ciao! 👋 Sono l'assistente virtuale dell'hotel. Posso verificare disponibilità e prezzi e rispondere a ogni domanda sul soggiorno. Come posso aiutarti?",
  teaser_pill_fixed: "Preventivo in 30 secondi ⚡",
  teaser_pills_rotating: [
    "C'è disponibilità per le tue date? 📅",
    "Che camere avete? 🛏️",
    "Com'è la colazione? 🥐",
  ],
  quote_pills: {
    alone: "Sono solo io",
    alone_message: "Sono solo io, una persona",
    party: "Siamo in {n}",
    party_message: "Siamo in {n} persone",
  },
  replies_in_realtime: "Risposte in tempo reale",
  ai_disclosure: "Sono l'assistente AI della struttura. Può chiedere dello staff quando preferisce.",
  powered_by: "Sviluppato da",
  type_a_message: "Scrivi un messaggio...",
  speak_with_operator: "Parla con un operatore",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Chiamaci al telefono",
    subtitle: "Risponde subito il nostro assistente vocale",
    badge: "Nuovo",
    call: "Chiama",
    copy: "Copia il numero",
    copied: "Numero copiato",
  },
  continue_on_whatsapp: "Continua su WhatsApp",
  whatsapp_handoff_prefill:
    "Ciao! Stavo scrivendo con l'assistente sul sito e vorrei continuare qui.",
  request_quote: "Richiedi un preventivo",
  map_directions: "Apri su Maps",
  handoff_form: {
    title: "Contattaci",
    desc: "Lasciaci i tuoi dati e il nostro team ti ricontatterà il prima possibile.",
    firstname: "Nome",
    lastname: "Cognome",
    email: "Email",
    phone: "Telefono",
    phone_hint: "Lo useremo per contattarti, anche su WhatsApp.",
    phone_search: "Cerca paese",
    submit: "Invia Richiesta",
    success:
      "Grazie! Abbiamo ricevuto i tuoi dati e ti ricontatteremo il prima possibile. 😊",
    handoff_email_success:
      "Ti rispondiamo via email a {email}. Puoi chiudere questa pagina.",
    submit_error: "Qualcosa è andato storto. Riprova tra poco.",
    firstname_error: "Inserisci il tuo nome.",
    lastname_error: "Inserisci il tuo cognome.",
    email_error: "Inserisci un indirizzo email valido.",
    phone_error: "Inserisci un numero di telefono valido.",
  },
  delete_chat_aria_label: "Elimina Conversazione",
  close_aria_label: "Chiudi Conversazione",
  send_aria_label: "Invia Messaggio",
  open_content: "Apri Contenuti",
  book_now: "Prenota Ora",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "Scrivi un'email",
  call_now: "Chiama",
  whatsapp_chat: "Scrivici su WhatsApp",
  open_link: "Apri il link",
  discover_hotel: "Scopri l’hotel",
  discover_offer: "Scopri l’offerta",
  quick_quote: "Chiedi un preventivo",
  view_hotel_photos: "Guarda le foto dell’hotel",
  view_photos: "Guarda le foto",
  hotel_gallery: "Hotel",
  restaurant_gallery: "Ristorante",
  animation_gallery: "Animazione",
  rooms_gallery: "Camere",
  look_hotel_galleries: "Guarda le altre gallery dell'hotel:",
  back_to_chat: "Torna alla chat",
  carousel_open: "Apri",
  carousel_close: "Chiudi",
  available: "Disponibile",
  expand_view: "Vista immersiva",
  read_more: "Leggi di più",
  explore: "Esplora",
  photo: "Foto",
  from_price: "da",
  rates: "Tariffe",
  quote_group: {
    title: "Il vostro preventivo",
    total: "Totale",
    room: "Camera {n}",
    other_options: "Altre opzioni",
    rooms: "{n} camere",
    adult: "adulto",
    adults: "adulti",
    child: "bambino",
    children: "bambini",
  },
  anchor_rooms: "Le nostre proposte",
  anchor_discover: "Da scoprire",
  anchor_places: "Posizione e dintorni",
  anchor_videos: "Video",
  videos: "video",
  watch_video: "Guarda il video",
  feedback_useful: "Risposta utile",
  feedback_not_useful: "Poco utile",
  proposal: "proposta",
  proposals: "proposte",
  contents: "contenuti",
  places: "luoghi",
  explore_title: "Il tuo soggiorno",
  explore_rooms: "Camere e tariffe",
  explore_discover: "Da scoprire",
  explore_videos: "Video",
  explore_places: "Luoghi",
  directions: "Indicazioni",
  minimize_view: "Riduci",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "Il tuo itinerario",
  itinerary: "Itinerario",
  stops: "tappe",
  stop: "tappa",
  walk_min: "min a piedi",
  itinerary_start: "Punto di partenza",
  your_hotel: "Il tuo hotel",
  explore_itineraries: "Itinerari",
  map_loading: "Carico la mappa…",
  cat_restaurant: "Mangiare e bere",
  cat_attraction: "Attrazioni",
  cat_beach: "Spiagge",
  cat_essential: "Servizi utili",
  cat_event: "Eventi",
  cat_place: "Luogo",
  reviews: "recensioni",

  // Flusso di prenotazione nel widget. In v0.5 gira contro il driver finto:
  // non viene riservato nulla da nessuna parte, ed è esattamente ciò che
  // mock_notice serve a dire ad alta voce.
  booking: {
    choose_rate: "Scegli la tariffa",
    your_details: "I tuoi dati",
    review: "Riepilogo",
    notes: "Note o richieste",
    notes_placeholder: "Allergie, orario di arrivo, culla…",
    privacy: "Ho letto e accetto l'informativa sulla privacy.",
    marketing: "Voglio ricevere offerte e novità dall'hotel.",
    privacy_required: "Serve il consenso privacy per procedere.",
    continue: "Continua",
    back: "Indietro",
    confirm: "Conferma prenotazione",
    submitting: "Un attimo…",
    cancel: "Annulla",
    close: "Chiudi",
    retry: "Riprova",
    total: "Totale",
    cheapest: "Più conveniente",
    per_night: "a notte",
    no_payment_now: "Nessun pagamento ora",
    nights: "notti",
    guests: "ospiti",
    reference: "Riferimento",
    success_title: "Prenotazione confermata",
    success_body: "Riceverai la conferma via email a breve.",
    error_title: "Non è andata a buon fine",
    error_body:
      "Non siamo riusciti a completare la prenotazione. Riprova tra poco.",
    mock_notice: "Modalità test: nessuna prenotazione reale è stata creata.",
  },
};

export default it;
